import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { UPDATE_DATA_REQUEST_ASYNC } from 'containers/Mailboxes/Management/VipDiscovery/constants'
import { addToast } from 'containers/Toasts/actions'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import {
  fetchDataError,
  fetchDataSuccess,
  updateVipUsersForScanbackError,
  updateVipUsersForScanbackSuccess,
} from './actions'
import { DATA_REQUEST_ASYNC, UPDATE_VIP_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DATA_REQUEST_ASYNC.INITIATE,
      UPDATE_VIP_REQUEST_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.incidents.scanbackOverview)
      return true
    })
    .mergeMap(() =>
      api.resolutionCenter
        .getScanbackData(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => fetchDataSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchDataError, error, [400])))
        .takeUntil(action$.ofType(DATA_REQUEST_ASYNC.CANCEL))
    )

const updateVipDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_VIP_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.mailboxes
      .updateVipUsersData(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.data?.map((e) => [e.profileId, e.title, true])
      )
      .mergeMap((response) => {
        if (response.response.vipProfilesLength) {
          return Observable.of(
            addToast({
              message: "'vip_impersonation' tags were successfully added to the selected profiles",
            }),
            updateVipUsersForScanbackSuccess(response)
          )
        } else {
          return Observable.of(updateVipUsersForScanbackError(response))
        }
      })
      .catch((error) => Observable.of(epicsErrorHandler(updateVipUsersForScanbackError, error)))
      .takeUntil(action$.ofType(UPDATE_DATA_REQUEST_ASYNC.CANCEL))
  )
export default combineEpics(fetchDataEpic, updateVipDataEpic)
